export function reverseChildZIndices(count = 10) {
  const css = [];

  for (let i = 0; i < count; i++) {
    css.push(`&:nth-child(${count - i}) { z-index: ${i + 1}; }`);
  }

  return css.join("\n");
}
